export default "__VITE_ASSET__Dfj2qcmT__"